import { withInstall } from '@fx-front-framework/utils/with-install'
import Tabs from './src/tabs.vue'

export const FxTabs = withInstall(Tabs)
export default FxTabs
